import {
  BugtrackerConfig,
  IntegrationConfig,
  NgBugtrackerMaintenanceWindowApiResource,
  NgBugtrackerMaintenanceWindowResource
} from '../shared'
import { ThisConnector } from '../../../../../api/connector'

export interface GetJiraBugtrackerArgs {
  organizationUuid?: string
  bugtrackerId: string
}

export interface GetJiraBugtrackerApiResponse {
  bugtracker: BugtrackerConfig
  integrations: IntegrationConfig[]
  maintenance_window?: NgBugtrackerMaintenanceWindowApiResource
}

export interface GetJiraBugtrackerResponse {
  bugtracker: BugtrackerConfig
  integrations: IntegrationConfig[]
  maintenanceWindow?: NgBugtrackerMaintenanceWindowResource
}

export async function getJiraBugtracker(
  this: ThisConnector,
  { organizationUuid, bugtrackerId }: GetJiraBugtrackerArgs
): Promise<GetJiraBugtrackerResponse> {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { bugtracker, integrations, maintenance_window } =
    await this.connector.get<GetJiraBugtrackerApiResponse>(
      `/${organizationUuid}/bugtrackers/jira/${bugtrackerId}?expand=skip_links`
    )

  return {
    bugtracker,
    integrations,
    maintenanceWindow: maintenance_window
      ? {
          recurrence: maintenance_window.recurrence,
          recurrenceDays: maintenance_window.recurrence_days,
          startTimeSeconds: maintenance_window.start_time_seconds,
          durationSeconds: maintenance_window.duration_seconds
        }
      : undefined
  }
}
